import React from 'react'
import { Card } from '@ui'

export function MetricCard({ label, value }) {
  return (
    <Card style={{ padding: '20px 24px', flex: 1 }}>
      <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 32, fontWeight: 600 }}>{value}</div>
    </Card>
  )
}
